import React from 'react';
import { Pie } from 'react-chartjs-2';

import '../../sass/components/charts/DistributionView.scss';

const COLORS = ['#04e494', '#2196F3'];

export default class DistributionView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    const values = [
      this.props.data.new,
      this.props.data.returning,
    ];
    return (
      <div className='distributionView'>
        <div className='chartContainer'>
          <Pie
            data={{
              labels: ['Returning', 'New'],
              datasets: [
                {
                  label: '',
                  data: values,
                  backgroundColor: COLORS,
                  borderWidth: 0,
                },
              ]
            }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
              },
            }}
            plugins={[
              {
                afterDatasetDraw: (chart, { index, meta }) => {
                  const values = [
                    this.props.data.new,
                    this.props.data.returning,
                  ];
                  const sum = values.reduce((res, cur) => res + cur, 0);
                  const ctx = chart.ctx;
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  meta.data.forEach((acrElem, index) => {
                    if (index === 0) {
                      ctx.fillStyle = 'rgba(0,0,0,0.87)';
                    } else {
                      ctx.fillStyle = '#ffffff';
                    }
                    const percent = Math.round(values[index] / sum * 100);

                    const angle = (acrElem.startAngle + acrElem.endAngle) / 2;
                    const x = (acrElem.outerRadius - 35) * Math.cos(angle) + acrElem.x;
                    const y = (acrElem.outerRadius - 35) * Math.sin(angle) + acrElem.y;
                    ctx.fillText(`${percent}% (${values[index]})`, x, y);
                  });
                  ctx.restore();
                },
              }
            ]}
          />
        </div>
        <div className='legend'>
          <label><span style={{backgroundColor: COLORS[1]}}/>New</label>
          <label><span style={{backgroundColor: COLORS[0]}}/>Returning</label>
        </div>
      </div>
    )
  }

}
